module.exports = __webpack_public_path__ + "img/watson3dsmall.dbbdbc11.gif";